import React from 'react'
import Accordions from "../../../components/Accordions";

const Sem2Eee1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1xaNO3jM1salmunfEA3w1YB6-EuBqeNEP/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1p7j9xBowrZYIgqzhDgHbXNR6CDDD4Mys/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2025-Batch/EEE-1-2-Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">EEE Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2Eee1